import React from 'react';
import { Box } from '@mui/material';
import Fee from './Fee';

const ConvenienceFeeSettings = ({
  defaultSettings,
  onUpdateSettings,
  fetchSettings,
}) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.convenience_fee && (
        <Fee
          settings={defaultSettings.convenience_fee}
          onUpdateSettings={onUpdateSettings}
          fetchSettings={fetchSettings}
        />
      )}
    </Box>
  );
};

export default ConvenienceFeeSettings;
